















































































import { Component, Vue } from 'vue-property-decorator'
import { v4 as uuid } from 'uuid'
import { TriggeredAction } from '@/api/model/triggered-action'
import { TriggeredActionAPI } from '@/api/backend-client'
import {
    ActionAssignToType,
    ActionType,
    DelayUnit,
    ReferralOrigin,
    TriggerType,
} from '@/api/types'
import { escapeHtml } from '@/helpers/html'

@Component
export default class CreateAutoActionPopout extends Vue {
    visible: boolean = false
    saving: boolean = false
    currentStep: number = 1
    triggeredAction: TriggeredAction = null
    triggeredActionExists: boolean = false

    async open() {
        this.triggeredAction = TriggeredAction.fromData( {
            id: uuid(),
            company: this.$currentCompany,
            triggerType: TriggerType.change,
            changedField: this.$currentCompany.pipelinesEnabled ? 'phase' : 'status',
            delayQuantity: 1,
            delayUnit: DelayUnit.minute,
            referralOrigin: ReferralOrigin.internal,
            actionType: ActionType.EMAIL,
            actionAssignToType: ActionAssignToType.assignedTo,
            actionComment: '',
        })
        this.triggeredActionExists = false
        this.currentStep = 1
        this.visible = true
    }

    async openWithExisting(triggeredAction: TriggeredAction) {
        this.triggeredAction = await TriggeredActionAPI.get(triggeredAction.id, true)
        this.triggeredActionExists = true
        this.currentStep = 1
        this.visible = true
    }

    close() {
        this.visible = false
    }

    async save(): Promise<void> {
        try {
            this.saving = true
            if (!this.triggeredActionExists) {
                await TriggeredActionAPI.create(this.triggeredAction)
            } else {
                await TriggeredActionAPI.update(this.triggeredAction.id, this.triggeredAction)
            }
            this.$emit('save')
            this.close()
        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })
        } finally {
            this.saving = false
        }
    }

    previousStep(): void {
        this.currentStep--
    }

    nextStep(): void {
        if (this.currentStep <= 3) {
            this.currentStep++
        } else {
            return
        }
    }
}
